import {
  insertEntry,
  updateEntry,
  deleteEntries,
  getEntries
} from '@/services/mongodb.js'

export default {
  state: {
    workplaces: []
  },
  getters: {
    workplaces: state => state.workplaces
  },
  mutations: {
    setWorkplaces(state, workplaces) {
      state.workplaces = workplaces
    },
    addWorkplace(state, workplace) {
      state.workplaces.push(workplace)
      return workplace
    },
    updateWorkplace(state, workplace) {
      const idx = state.workplaces.findIndex(c => c.id === workplace.id)
      state.workplaces[idx] = workplace
      state.workplaces = [...state.workplaces]
    },
    deleteWorkplaces(state, workplaces) {
      for (const { id } of workplaces) {
        const idx = state.workplaces.findIndex(c => c.id === id)
        state.workplaces.splice(idx, 1)
      }
    }
  },
  actions: {
    addWorkplace({ commit, rootState }, workplace) {
      const userId = rootState.user.user.id
      workplace.userId = userId
      return insertEntry('Locations', 'Workplaces', workplace).then(
        workplace => {
          return commit('addWorkplace', workplace)
        }
      )
    },
    updateWorkplace({ commit }, workplace) {
      return updateEntry('Locations', 'Workplaces', workplace).then(
        workplaceResult => {
          return commit('updateWorkplace', workplaceResult)
        }
      )
    },
    setWorkplaces({ commit }, workplaces) {
      commit('setWorkplaces', workplaces)
    },
    getWorkplaces({ commit, rootState }) {
      const userId = rootState.user.user.id
      return getEntries('Locations', 'Workplaces').then(workplaces => {
        commit('setWorkplaces', workplaces)
      })
    },
    deleteWorkplaces({ commit }, workplaces) {
      deleteEntries('Locations', 'Workplaces', workplaces).then(workplaces =>
        commit('deleteWorkplaces', workplaces)
      )
    }
  }
}
